
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/medferd-personuupplysinga",
      function () {
        return require("private-next-pages/um/fyrirtaekid/medferd-personuupplysinga.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/medferd-personuupplysinga"])
      });
    }
  